// extracted by mini-css-extract-plugin
export default {"input":"input_input__mKA96","light":"input_light__bEPDG","centeredText":"input_centeredText__pBtvd"};